import type { DocumentData } from '@redux/modules/documents';
import { useAuth0Token } from '../../hooks/useAuth0Token';
import { useDocumentData } from '../../hooks/Documents/useDocumentData';

/**
 * Documents under NafLocationsApp are resolved by slug alone, ignoring the URL path, so the API can
 * return a document of a different type than the route expects, or one with fields missing. Every
 * field is therefore optional: render what is available rather than assuming a shape.
 *
 * `document` is undefined only when nothing could be fetched at all — that is the one case worth a
 * NotFound. A document that was fetched always renders, however incomplete it is.
 */
export const useLocationDocument = <T extends DocumentData>(slug: string) => {
  const { simpleToken } = useAuth0Token();
  const { data, meta } = useDocumentData(slug, simpleToken);

  // The runtime shape is whatever the API returned for this slug, which need not be a T at all,
  // so this reinterprets rather than narrows — hence going via unknown.
  return { document: data as unknown as Partial<T> | undefined, meta };
};
